// extracted by mini-css-extract-plugin
export default {"root":"iGa2f4Q6Bx","cover":"hA6xwc5bNQ","infoSection":"i6X8FOQn7l","header":"N7Agq0gpwq","title":"CU9Xw_Xiyo","description":"ljd8RphI__"};